export default __webpack_public_path__ + "static/media/cert7.73d3aa22.jpg";